export default "__VITE_ASSET__JH5jzEDe__"